import { render, staticRenderFns } from "./request_logs.vue?vue&type=template&id=81120cb6"
import script from "./request_logs.vue?vue&type=script&lang=js"
export * from "./request_logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports